const drawer = document.getElementById("custom-cart-rafia"); 
const overlay = document.getElementById("custom-cart-rafia-overlay");

/* =======================
   AUTO SHOPIFY CURRENCY
======================= */

const currencyCode = window.Shopify?.currency?.active || "BDT";

function formatMoney(cents) {
  const amount = Number(cents || 0) / 100;

  if (currencyCode === "BDT") {
    return `Tk ${amount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (e) {
    return `${currencyCode} ${amount.toFixed(2)}`;
  }
}


let cartCache = null;


/* =======================
   COMPARE PRICE CACHE
======================= */

const comparePriceCache = {};


/* =======================
   GET COMPARE-AT PRICES
======================= */

async function addComparePrices(cart) {

  await Promise.all(
    cart.items.map(async (item) => {

      try {

        const productPath = item.url.split("?")[0] + ".js";

        let product;

        if (comparePriceCache[productPath]) {

          product = comparePriceCache[productPath];

        } else {

          const response = await fetch(productPath);

          product = await response.json();

          comparePriceCache[productPath] = product;
        }


        const variant = product.variants.find(
          v => Number(v.id) === Number(item.variant_id)
        );


        item.compare_at_price =
          variant?.compare_at_price || 0;


      } catch (error) {

        console.log("Compare price error:", error);

        item.compare_at_price = 0;

      }

    })
  );


  return cart;
}



// =======================
// PRELOAD CART
// =======================

fetch("/cart.js")
  .then(r => r.json())
  .then(data => addComparePrices(data))
  .then(data => {

    cartCache = data;

    updateHeaderCartCount(data.item_count);

  });



// =======================
// HEADER COUNT
// =======================

function updateHeaderCartCount(count) {

  const bubble = document.querySelector(
    ".cart-count-bubble"
  );

  if (bubble) {
    bubble.style.display = "none";
  }

}



// =======================
// OPEN / CLOSE
// =======================

function openCartRafia() {

  drawer.classList.add("active");

  overlay.classList.add("active");


  if (cartCache) {

    renderCart(cartCache);

  }


  refreshCart();

}



function closeCartRafia() {

  drawer.classList.remove("active");

  overlay.classList.remove("active");

}



document
  .getElementById("ccr-close")
  ?.addEventListener(
    "click",
    closeCartRafia
  );


overlay?.addEventListener(
  "click",
  closeCartRafia
);



// =======================
// REAL REFRESH
// =======================

function refreshCart() {

  fetch("/cart.js")

    .then(r => r.json())

    .then(data => addComparePrices(data))

    .then(data => {

      cartCache = data;

      renderCart(data);

    });

}



// =======================
// SAFE OPTIMISTIC QTY
// =======================

function changeQty(key, newQty) {

  const row =
    document.querySelector(
      `[data-key="${key}"]`
    );


  if (
    newQty === 0 &&
    row
  ) {

    row.style.opacity = "0.3";

  }


  fetch("/cart/change.js", {

    method: "POST",

    headers: {
      "Content-Type": "application/json"
    },

    body: JSON.stringify({
      id: key,
      quantity: newQty
    })

  }).then(refreshCart);

}



// =======================
// RENDER
// =======================

function renderCart(cart) {

  updateCrossSellVisibility(cart);


  updateHeaderCartCount(
    cart.item_count
  );


  const itemsDiv =
    document.getElementById(
      "ccr-items"
    );


  const footer =
    document.querySelector(
      ".ccr-footer-outer"
    );

  const crossSell =
  document.querySelector(
    ".ccr-cross-sell"
  );  


  if (!itemsDiv) return;



  // =======================
  // EMPTY CART
  // =======================

  if (cart.item_count === 0) {


    if (footer) {

      footer.style.display =
        "none";

    }
      
       if (crossSell) {
  crossSell.style.display = "none";
}

    itemsDiv.innerHTML = `

      <div
        class="ccr-empty-state"
        style="
          display:flex;
          flex-direction:column;
          align-items:center;
          justify-content:center;
          height:100%;
          text-align:center;
          padding:50px 20px;
        "
      >

        <p
          style="
            font-size:16px;
            margin-bottom:20px;
            text-transform:lowercase;
          "
        >
          your bag is empty
        </p>


        <button
          onclick="closeCartRafia()"
          class="ccr-explore-btn"
          style="
            background:#000;
            color:#fff;
            padding:12px 30px;
            border-radius:25px;
            border:none;
            cursor:pointer;
            font-size:12px;
            font-weight:700;
            text-transform:uppercase;
            letter-spacing:1px;
          "
        >
          explore products
        </button>

      </div>

    `;


    return;

  }



  if (footer) {

    footer.style.display =
      "block";

  }

    if (crossSell) {
  crossSell.style.display = "block";
}



  // =======================
  // CART TOTAL
  // =======================

  const totalElement =
    document.getElementById(
      "ccr-total"
    );


  if (totalElement) {

    totalElement.innerText =
      formatMoney(
        cart.total_price
      );

  }



  itemsDiv.innerHTML = "";



  cart.items.forEach(item => {


    // =======================
    // 🔥 VARIANT LOGIC
    // ORIGINAL
    // =======================

    let variantHTML = '';


    if (

      item.options_with_values &&

      item.options_with_values.length > 0 &&

      item.variant_title &&

      item.variant_title !== "Default Title"

    ) {


      const parts =
        item.options_with_values.map(
          opt => {


            if (
              !opt.value ||
              opt.value ===
                "Default Title"
            ) {

              return '';

            }



            if (
              opt.name
                .toLowerCase()
                .includes('color')
            ) {


              let value =
                opt.value
                  .toLowerCase();


              let color =
                value;



              if (
                value.includes(
                  'light'
                )
              ) {

                color =
                  value
                    .replace(
                      'light',
                      ''
                    )
                    .trim();

              }



              if (
                value.includes(
                  'dark'
                )
              ) {

                color =
                  value
                    .replace(
                      'dark',
                      ''
                    )
                    .trim();

              }



              const gradientMap = {

                beige:
                  "linear-gradient(45deg,#f5f5dc,#e8dcc0)",

                gold:
                  "linear-gradient(45deg,#d4af37,#f5d76e)",

                silver:
                  "linear-gradient(45deg,#c0c0c0,#e5e5e5)",

                bronze:
                  "linear-gradient(45deg,#cd7f32,#e0a96d)",

                navy:
                  "linear-gradient(45deg,#000080,#1a1a5c)",

                grey:
                  "linear-gradient(45deg,#808080,#b0b0b0)"

              };



              let finalColor =
                gradientMap[value] ||
                color;



              return `

                <span
                  style="
                    display:inline-block;
                    width:12px;
                    height:12px;
                    border-radius:50%;
                    background:${finalColor};
                    border:1px solid #ccc;
                  "
                ></span>

              `;

            }



            return `

              <span
                style="
                  font-size:11px;
                  color:#555;
                  text-transform:uppercase;
                "
              >
                ${opt.value}
              </span>

            `;


          }

        ).filter(Boolean);



      if (
        parts.length > 0
      ) {


        variantHTML = `

          <div
            class="item-variants"
            style="
              display:flex;
              gap:6px;
              margin:4px 0 6px 0;
            "
          >

            ${parts.join('')}

          </div>

        `;

      }

    }



    // =======================
    // MAIN PRICE
    // DISCOUNT PRICE
    // SAVING
    // =======================

    const currentPrice =
      Number(
        item.final_line_price ||
        0
      );


    const comparePrice =
      Number(
        item.compare_at_price ||
        0
      ) * item.quantity;


    let priceHTML = '';



    if (
      comparePrice >
      currentPrice
    ) {


      const savingAmount =
        comparePrice -
        currentPrice;


      priceHTML = `

        <div class="item-price-wrap">

          <span class="item-old-price">

            ${formatMoney(
              comparePrice
            )}

          </span>


          <span class="item-sale-price">

            ${formatMoney(
              currentPrice
            )}

          </span>


          <span class="item-saving">

            YOU SAVE ${formatMoney(
              savingAmount
            )}

          </span>

        </div>

      `;


    } else if (

      item.original_line_price >

      currentPrice

    ) {


      const originalPrice =
        Number(
          item.original_line_price
        );


      const savingAmount =
        originalPrice -
        currentPrice;


      priceHTML = `

        <div class="item-price-wrap">

          <span class="item-old-price">

            ${formatMoney(
              originalPrice
            )}

          </span>


          <span class="item-sale-price">

            ${formatMoney(
              currentPrice
            )}

          </span>


          <span class="item-saving">

            YOU SAVE ${formatMoney(
              savingAmount
            )}

          </span>

        </div>

      `;


    } else {


      priceHTML = `

        <div class="item-price-wrap">

          <span class="item-sale-price">

            ${formatMoney(
              currentPrice
            )}

          </span>

        </div>

      `;

    }



    // =======================
    // ORIGINAL HTML
    // =======================

    itemsDiv.innerHTML += `

      <div
        class="cart-item-row"
        data-key="${item.key}"
      >

        <img src="${item.image}">


        <div class="item-info">


          <div class="item-title">

            ${item.product_title}

          </div>



          ${variantHTML}



          ${priceHTML}



          <div class="qty-remove-row">


            <div class="qty-wrapper">


              <button
                class="qty-btn"
                onclick="changeQty(
                  '${item.key}',
                  ${item.quantity - 1}
                )"
              >
                -
              </button>



              <input
                class="qty-input"
                type="text"
                value="${item.quantity}"
                readonly
              >



              <button
                class="qty-btn"
                onclick="changeQty(
                  '${item.key}',
                  ${item.quantity + 1}
                )"
              >
                +
              </button>


            </div>



            <div
              class="remove-btn"
              onclick="changeQty(
                '${item.key}',
                0
              )"
            >
              remove
            </div>


          </div>


        </div>


      </div>

    `;

  });

}



// =======================
// ADD TO CART
// =======================

if (
  !window.__rafiaCartBound
) {


  window.__rafiaCartBound =
    true;



  document.addEventListener(

    "submit",

    function(e) {


      if (
        e.target.matches(
          "form[action='/cart/add']"
        )
      ) {


        e.stopImmediatePropagation();


        e.preventDefault();



        const form =
          e.target;



        const section =
          form.closest(
            ".sanjila"
          );



        let variantId =
          null;



        if (
          section &&
          window.__getSelectedVariant
        ) {


          const variant =
            window.__getSelectedVariant(
              section
            );



          if (
            !variant ||
            variant.available === false
          ) {


            alert(
              "This variant is out of stock"
            );


            return;

          }



          variantId =
            variant.id;

        }



        if (!variantId) {


          variantId =

            form
              .querySelector(
                'input[name="id"]'
              )
              ?.value;

        }



        const quantity =

          form
            .querySelector(
              '[name="quantity"]'
            )
            ?.value || 1;



        fetch(
          "/cart/add.js",
          {

            method:
              "POST",

            headers: {

              "Content-Type":
                "application/json"

            },

            body:
              JSON.stringify({

                id:
                  variantId,

                quantity:
                  quantity

              })

          }

        ).then(() => {


          refreshCart();


          openCartRafia();


        });

      }

    },

    true

  );

}



// =======================
// ICON HIJACK
// =======================

document.addEventListener(

  "DOMContentLoaded",

  function () {


    const cartIcon =

      document.getElementById(
        "cart-icon-bubble"
      );



    if (!cartIcon) return;



    cartIcon.addEventListener(

      "click",

      function (e) {


        e.preventDefault();


        openCartRafia();


      }

    );

  }

);









/* =========================================================
   CART CROSS SELL
   CLICK CARD → ADD PRODUCT → KEEP DRAWER OPEN
========================================================= */

if (!window.__ccrCrossSellBound) {

  window.__ccrCrossSellBound = true;


  document.addEventListener(
    "click",

    async function (event) {

      const card =
        event.target.closest(
          ".ccr-cross-card"
        );


      if (!card) return;


      event.preventDefault();


      if (
        card.classList.contains(
          "is-adding"
        )
      ) {
        return;
      }


      const variantId =
        Number(
          card.dataset.variantId
        );


      if (!variantId) {

        console.error(
          "Cross sell variant ID missing"
        );

        return;
      }


      card.classList.add(
        "is-adding"
      );


      try {


        const response =
          await fetch(
            "/cart/add.js",

            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json"
              },

              body: JSON.stringify({
                id: variantId,
                quantity: 1
              })
            }
          );


        const result =
          await response.json();


        if (!response.ok) {

          throw new Error(
            result.description ||
            result.message ||
            "Unable to add product."
          );

        }


        /* VISUAL CONFIRMATION */

        card.classList.remove(
          "is-adding"
        );

        card.classList.add(
          "is-added"
        );


        setTimeout(
          function () {

            card.classList.remove(
              "is-added"
            );

          },
          700
        );


        /*
          Update current cart items,
          totals and quantities.
        */

        refreshCart();


        /*
          Make sure drawer stays open.
        */

        openCartRafia();


      }

      catch (error) {

        card.classList.remove(
          "is-adding"
        );


        console.error(
          "CCR cross sell error:",
          error
        );


        alert(
          error.message ||
          "Something went wrong."
        );

      }

    }
  );

}








/* =========================================================
   HIDE CROSS-SELL PRODUCTS ALREADY IN CART
========================================================= */

function updateCrossSellVisibility(cart) {

  const cartVariantIds = new Set(
    cart.items.map(item => Number(item.variant_id))
  );

  document.querySelectorAll(".ccr-cross-card").forEach(card => {

    const variantId = Number(card.dataset.variantId);

    if (variantId && cartVariantIds.has(variantId)) {
      card.style.display = "none";
    } else {
      card.style.display = "";
    }

  });

}



/* =========================================================
   CART CROSS SELL — GRAB & DRAG SCROLL
   Same behavior as your product slider
========================================================= */

document
  .querySelectorAll(".ccr-cross-sell__track")
  .forEach(function (slider) {

    if (
      slider.dataset.dragScrollReady === "true"
    ) {
      return;
    }

    slider.dataset.dragScrollReady = "true";


    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;


    /* =========================
       DESKTOP MOUSE DOWN
    ========================= */

    slider.addEventListener(
      "mousedown",
      function (e) {

        if (e.button !== 0) return;

        isDown = true;
        moved = false;

        startX = e.clientX;
        scrollLeft = slider.scrollLeft;

        slider.classList.add(
          "grabbing"
        );

        e.preventDefault();

      }
    );


    /* =========================
       DESKTOP DRAG
    ========================= */

    window.addEventListener(
      "mousemove",
      function (e) {

        if (!isDown) return;

        const walk =
          (e.clientX - startX) * 2;

        if (
          Math.abs(walk) > 3
        ) {
          moved = true;
        }

        slider.scrollLeft =
          scrollLeft - walk;

        e.preventDefault();

      }
    );


    /* =========================
       RELEASE
    ========================= */

    window.addEventListener(
      "mouseup",
      function () {

        if (!isDown) return;

        isDown = false;

        slider.classList.remove(
          "grabbing"
        );

      }
    );


    /* =========================
       PREVENT ACCIDENTAL ADD
       AFTER DRAGGING
    ========================= */

    slider.addEventListener(
      "click",
      function (e) {

        if (moved) {

          e.preventDefault();
          e.stopImmediatePropagation();

          moved = false;

        }

      },
      true
    );


    slider
      .querySelectorAll(
        "a, button, .ccr-cross-card"
      )
      .forEach(function (el) {

        el.addEventListener(
          "click",
          function (e) {

            if (moved) {

              e.preventDefault();
              e.stopImmediatePropagation();

              moved = false;

            }

          },
          true
        );

      });

  });